import React from 'react';
import './Experience.css';
import { FaHtml5 } from 'react-icons/fa';
import { DiCss3 } from 'react-icons/di';
import { DiJavascript1 } from 'react-icons/di';
import { SiTailwindcss } from 'react-icons/si';
import { GrReactjs } from 'react-icons/gr'
import { FaPython } from 'react-icons/fa';
import { SiDjango } from 'react-icons/si';
import { DiMongodb } from 'react-icons/di';
import { SiMysql } from 'react-icons/si';
import { DiNodejsSmall } from 'react-icons/di'
import { AiOutlineCode } from 'react-icons/ai'
import { SiGoland } from 'react-icons/si'
import { SiTypescript } from 'react-icons/si'
import { SiKotlin } from 'react-icons/si'
const Experience = () => {
  return (
    <section id="experience">
      <h5>Familiar Technologies</h5>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Language Stack</h3>
          <div className="experience__content">
            <article className="experience__details">
              <FaHtml5 className=" experience__details-icon"/>
              <div>
                <h4>HTML & CSS</h4>
                <small className="text-light">Expert</small>
              </div>
            </article>
            <article className="experience__details">
              <SiKotlin  className=" experience__details-icon"/>
              <div>
                <h4>Kotlin</h4>
                <small className="text-light">Expert</small>
              </div>
            </article>
            <article className="experience__details">
              <DiJavascript1  className=" experience__details-icon"/>
              <div>
                <h4>Javascript</h4>
                <small className="text-light">Expert</small>
              </div>
            </article>
            <article className="experience__details">
              <SiGoland className=" experience__details-icon"/>
              <div>
                <h4>Golang</h4>
                <small className="text-light">Expert</small>
              </div>
            </article>
            <article className="experience__details">
              <SiTypescript className=" experience__details-icon"/>
              <div>
                <h4>Typescript</h4>
                <small className="text-light">Expert</small>
              </div>
            </article>
            
            <article className="experience__details">
              <FaPython className=" experience__details-icon"/>
              <div>
                <h4>Python</h4>
                <small className="text-light">Expert</small>
              </div>
            </article>
          </div>
        </div>
        {/* backend */}
        <div className="experience__backend">
          <div className="experience__frontend">
            <h3>Technologies</h3>
            <div className="experience__content">
              <article className="experience__details">
                <AiOutlineCode  className=" experience__details-icon"/>
                <div>
                  <h4>Express JS</h4>
                  <small className="text-light">Expert</small>
                </div>
              </article>
              <article className="experience__details">
                <DiMongodb  className=" experience__details-icon"/>
                <div>
                  <h4>MONGODB</h4>
                  <small className="text-light">Expert</small>
                </div>
              </article>
              <article className="experience__details">
                <SiMysql  className=" experience__details-icon"/>
                <div>
                  <h4>MySQL</h4>
                  <small className="text-light">Expert</small>
                </div>  
              </article>
              <article className="experience__details">
                <DiNodejsSmall  className=" experience__details-icon"/>
                <div>
                  <h4>NODE JS</h4>
                  <small className="text-light">Expert</small>
                </div>
              </article>
               <article className="experience__details">
              <SiTailwindcss  className=" experience__details-icon"/>
              <div>
                <h4>Tailwind</h4>
                <small className="text-light">Experienced</small>
              </div>
              </article>
              <article className="experience__details">
              <GrReactjs  className=" experience__details-icon"/>
              <div>
                <h4>React</h4>
                <small className="text-light">Expert</small>
              </div>
            </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
